module.exports = __webpack_public_path__ + "img/questions.6267b7c4.svg";